import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"],
  _excluded3 = ["totalHubSeatsCount"],
  _excluded4 = ["data"];
import { useQuery } from 'data-fetching-client';
import { GET_SEATS_INVENTORY } from 'pricing-pages-api/seats-inventory/queries';
import { SEATS_INVENTORY } from 'pricing-pages-lib/constants/EarlyRequesterNames';
import { getAllPurchasableSeatTypesWithSkuIds } from 'pricing-pages-lib/utils/seatsInventoryUtils';
import { SeatType } from 'ui-addon-upgrades/_core/common/api/fetchAvailableSeats';
import { useAppSelector } from '../reducers';
import { productDataSelector, productInventorySelector } from '../selectors/SelectorUtils';
import { useStagedUsersFromSeatRequests } from './useSeatRequests';
export const useSeatsInventory = () => {
  return useQuery(GET_SEATS_INVENTORY, {
    variables: {
      earlyRequestName: SEATS_INVENTORY
    }
  });
};
export const useTotalHubSeatsCountForSeatType = seatType => {
  const _useSeatsInventory = useSeatsInventory(),
    {
      data
    } = _useSeatsInventory,
    queryResult = _objectWithoutPropertiesLoose(_useSeatsInventory, _excluded);
  let totalHubSeatsCount = 0;
  if (data !== null && data !== void 0 && data.seatsInventory) {
    const {
      paidSeats
    } = data.seatsInventory;
    const seatsInfo = paidSeats.find(({
      seatName
    }) => seatName === seatType);
    totalHubSeatsCount = (seatsInfo === null || seatsInfo === void 0 ? void 0 : seatsInfo.maxAssignableSeats) || 0;
  }
  return Object.assign({
    totalHubSeatsCount
  }, queryResult);
};
export const useTotalUsers = () => {
  const _useSeatsInventory2 = useSeatsInventory(),
    {
      data
    } = _useSeatsInventory2,
    queryResult = _objectWithoutPropertiesLoose(_useSeatsInventory2, _excluded2);
  const {
    stagedUsersList
  } = useStagedUsersFromSeatRequests();
  let activeUsers = 0;
  if (data !== null && data !== void 0 && data.seatsInventory) {
    const {
      paidSeats
    } = data.seatsInventory;
    activeUsers = paidSeats.reduce((acc, paidSeat) => acc + paidSeat.currentAssignedSeats, 0);
  }
  const stagedUsers = (stagedUsersList === null || stagedUsersList === void 0 ? void 0 : stagedUsersList.length) || 0;

  // The total number of users will be the current active users combined with staged users
  const totalUsers = activeUsers + stagedUsers;
  return Object.assign({
    totalUsers,
    stagedUsers
  }, queryResult);
};
export const useHasSalesAndServiceSeats = () => {
  const {
    totalHubSeatsCount: salesProSeatsCount
  } = useTotalHubSeatsCountForSeatType(SeatType.SALES_PRO);
  const _useTotalHubSeatsCoun = useTotalHubSeatsCountForSeatType(SeatType.SERVICE_PROFESSIONAL),
    {
      totalHubSeatsCount: serviceProSeatsCount
    } = _useTotalHubSeatsCoun,
    queryResult = _objectWithoutPropertiesLoose(_useTotalHubSeatsCoun, _excluded3);
  const hasSalesAndServiceSeats = salesProSeatsCount > 0 && serviceProSeatsCount > 0;
  return Object.assign({
    hasSalesAndServiceSeats
  }, queryResult);
};
export const useAllPurchasableSeatTypesWithSkuIds = () => {
  const _useSeatsInventory3 = useSeatsInventory(),
    {
      data
    } = _useSeatsInventory3,
    queryResult = _objectWithoutPropertiesLoose(_useSeatsInventory3, _excluded4);
  const productData = useAppSelector(state => productDataSelector(state));
  const productInventory = useAppSelector(state => productInventorySelector(state));
  let allPurchasableSeatTypes = undefined;
  if (data !== null && data !== void 0 && data.seatsInventory) {
    allPurchasableSeatTypes = getAllPurchasableSeatTypesWithSkuIds({
      productData,
      productInventory
    }, data === null || data === void 0 ? void 0 : data.seatsInventory);
  }
  return Object.assign({
    allPurchasableSeatTypes
  }, queryResult);
};